import { jsxs as s, jsx as l } from "react/jsx-runtime";
function r({ header: e, nav: a, children: n, footer: i }) {
  return /* @__PURE__ */ s("div", { className: "aiskills-layout", children: [
    /* @__PURE__ */ l("a", { href: "#aiskills-main", className: "aiskills-layout__skip", children: "Skip to main content" }),
    /* @__PURE__ */ l("header", { className: "aiskills-layout__header", role: "banner", children: e }),
    /* @__PURE__ */ s("div", { className: "aiskills-layout__body", children: [
      a ? /* @__PURE__ */ l("nav", { className: "aiskills-layout__nav", "aria-label": "Primary", children: a }) : null,
      /* @__PURE__ */ l("main", { id: "aiskills-main", className: "aiskills-layout__main", role: "main", children: n })
    ] }),
    i ? /* @__PURE__ */ l("footer", { className: "aiskills-layout__footer", role: "contentinfo", children: i }) : null
  ] });
}
export {
  r as Layout
};
//# sourceMappingURL=Layout.js.map
